<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom:10px;" style="margin-bottom: 15px">
      <div class="ele-table-tool">
        <div class="ele-table-tool-title">班级量化考评结果</div>
      </div>
      <ele-data-table ref="table" :config="table" :data="data" :choose.sync="choose" highlight-current-row height="calc(100vh - 200px)">
        <template>
          <!--          <el-table-column type="selection" width="45" align="center" />-->
          <el-table-column prop="className" label="班级名称" show-overflow-tooltip />
          <el-table-column prop="score" label="分数" show-overflow-tooltip />
          <el-table-column label="操作" align="center">
            <template #default="{ row }">
              <el-link @click="getDetail(row)" icon="el-icon-edit" type="primary" :underline="false">明细</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <el-dialog title="查看明细" :visible.sync="showDetail" width="60%">
      <el-form
        :model="detailTable.where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="$refs.detailTable.reload()"
        @submit.native.prevent
      >
        <el-row :gutter="15">
          <el-col :md="10" :sm="12">
            <el-form-item label="日期选择:">
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="medium"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                :unlink-panels="true"
            /></el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="searchDetail" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div style="font-size: 20px;text-align: center;margin: 10px auto;font-weight: bolder;">分值：{{ score }}分</div>
      <ele-data-table ref="detailTable" :config="detailTable" :row-key="getRowKey" :initLoad="true" height="calc(90vh - 300px)" highlight-current-row>
        <template #default="{ index }">
          <!--          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />-->
          <el-table-column prop="itemName" label="指标名称" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="score" label="指标得分" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="teacherName" label="考评教师" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="createTime" label="考评时间" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="remark" label="备注" sortable="custom" show-overflow-tooltip />
        </template>
      </ele-data-table>
    </el-dialog>
  </div>
</template>

<script>
  import { getClassAssessReport } from '@/config/api';
  var score = 0;
  export default {
    name: 'Index',
    data() {
      return {
        table: {
          page: false,
        },
        data: [],
        choose: [],
        detailTable: {
          // 表格配置
          url: '/school/report/getClassAssessReportDetail',
          where: { classId: '' },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            score = res.data.totalScore;
            res.score = res.data.totalScore;
            res.count = res.data.list.total;
            res.data = res.data.list.records;

            return res;
          },
        },
        score: null,
        showDetail: false,
        date: null,
        aa: null,
        getRowKey(row) {
          return row.id;
        },
      };
    },
    created() {
      this.getData();
    },
    methods: {
      // 获取宿舍考核汇总
      getData() {
        getClassAssessReport().then((res) => {
          if (res.data.resCode == 200) {
            this.data = res.data.data;
          }
        });
      },
      // 默认本月日期
      setSelectTime() {
        var _this = this;
        var date = new Date();
        var y = date.getFullYear();
        var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

        var start_month = y + '-' + '01'; //开始月份：本年第一月份
        var end_month = `${y}-${m}`; //结束月份： 本年当前月份

        var start_day = y + '-' + m + '-' + '01'; //开始日期： 本月第一天
        var end_day = `${y}-${m}-${d}`; //结束日期： 本月今天

        _this.aa = [start_month, end_month]; //默认月份区间
        _this.date = [start_day, end_day]; //默认日期区间  页面显示的
        this.detailTable.where.startTime = start_day; // 传入后台的 开始时间
        this.detailTable.where.endTime = end_day; // 传入后台的 结束时间
      },
      getDetail(row) {
        this.setSelectTime();
        this.detailTable.where.classId = row.id;
        this.showDetail = true;
        this.$refs.detailTable.reload();
        setTimeout(() => {
          this.score = score;
        }, 300);
      },
      searchDetail() {
        this.detailTable.where.startTime = this.date[0];
        this.detailTable.where.endTime = this.date[1];
        this.$refs.detailTable.reload();
      },
    },
  };
</script>

<style scoped></style>
